/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useMutation } from 'react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type {
  EmailRequestBankWelcomeMessage,
  EmailRequestComplianceWorklistRequest,
  EmailRequestNewUserInvite,
  EmailRequestProductApproved,
  EmailRequestProductPublished,
  EmailRequestRateChangeApproved,
} from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const sendInterventionMessage = (
  emailRequestComplianceWorklistRequest: EmailRequestComplianceWorklistRequest
) => {
  return customInstance<void>({
    url: `/operations/mail/compliance-intervention`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailRequestComplianceWorklistRequest,
  });
};

export const getSendInterventionMessageMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInterventionMessage>>,
    TError,
    { data: EmailRequestComplianceWorklistRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendInterventionMessage>>,
  TError,
  { data: EmailRequestComplianceWorklistRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendInterventionMessage>>,
    { data: EmailRequestComplianceWorklistRequest }
  > = (props) => {
    const { data } = props ?? {};

    return sendInterventionMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendInterventionMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendInterventionMessage>>
>;
export type SendInterventionMessageMutationBody =
  EmailRequestComplianceWorklistRequest;
export type SendInterventionMessageMutationError = unknown;

export const useSendInterventionMessage = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInterventionMessage>>,
    TError,
    { data: EmailRequestComplianceWorklistRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendInterventionMessage>>,
  TError,
  { data: EmailRequestComplianceWorklistRequest },
  TContext
> => {
  const mutationOptions = getSendInterventionMessageMutationOptions(options);

  return useMutation(mutationOptions);
};
export const sendNewUserMessage = (
  emailRequestNewUserInvite: EmailRequestNewUserInvite
) => {
  return customInstance<void>({
    url: `/operations/mail/new-user`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailRequestNewUserInvite,
  });
};

export const getSendNewUserMessageMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendNewUserMessage>>,
    TError,
    { data: EmailRequestNewUserInvite },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendNewUserMessage>>,
  TError,
  { data: EmailRequestNewUserInvite },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendNewUserMessage>>,
    { data: EmailRequestNewUserInvite }
  > = (props) => {
    const { data } = props ?? {};

    return sendNewUserMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendNewUserMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendNewUserMessage>>
>;
export type SendNewUserMessageMutationBody = EmailRequestNewUserInvite;
export type SendNewUserMessageMutationError = unknown;

export const useSendNewUserMessage = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendNewUserMessage>>,
    TError,
    { data: EmailRequestNewUserInvite },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendNewUserMessage>>,
  TError,
  { data: EmailRequestNewUserInvite },
  TContext
> => {
  const mutationOptions = getSendNewUserMessageMutationOptions(options);

  return useMutation(mutationOptions);
};
export const sendProductApprovedMessage = (
  emailRequestProductApproved: EmailRequestProductApproved
) => {
  return customInstance<void>({
    url: `/operations/mail/product-approved`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailRequestProductApproved,
  });
};

export const getSendProductApprovedMessageMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendProductApprovedMessage>>,
    TError,
    { data: EmailRequestProductApproved },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendProductApprovedMessage>>,
  TError,
  { data: EmailRequestProductApproved },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendProductApprovedMessage>>,
    { data: EmailRequestProductApproved }
  > = (props) => {
    const { data } = props ?? {};

    return sendProductApprovedMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendProductApprovedMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendProductApprovedMessage>>
>;
export type SendProductApprovedMessageMutationBody =
  EmailRequestProductApproved;
export type SendProductApprovedMessageMutationError = unknown;

export const useSendProductApprovedMessage = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendProductApprovedMessage>>,
    TError,
    { data: EmailRequestProductApproved },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendProductApprovedMessage>>,
  TError,
  { data: EmailRequestProductApproved },
  TContext
> => {
  const mutationOptions = getSendProductApprovedMessageMutationOptions(options);

  return useMutation(mutationOptions);
};
export const sendProductPublishedMessage = (
  emailRequestProductPublished: EmailRequestProductPublished
) => {
  return customInstance<void>({
    url: `/operations/mail/product-published`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailRequestProductPublished,
  });
};

export const getSendProductPublishedMessageMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendProductPublishedMessage>>,
    TError,
    { data: EmailRequestProductPublished },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendProductPublishedMessage>>,
  TError,
  { data: EmailRequestProductPublished },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendProductPublishedMessage>>,
    { data: EmailRequestProductPublished }
  > = (props) => {
    const { data } = props ?? {};

    return sendProductPublishedMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendProductPublishedMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendProductPublishedMessage>>
>;
export type SendProductPublishedMessageMutationBody =
  EmailRequestProductPublished;
export type SendProductPublishedMessageMutationError = unknown;

export const useSendProductPublishedMessage = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendProductPublishedMessage>>,
    TError,
    { data: EmailRequestProductPublished },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendProductPublishedMessage>>,
  TError,
  { data: EmailRequestProductPublished },
  TContext
> => {
  const mutationOptions =
    getSendProductPublishedMessageMutationOptions(options);

  return useMutation(mutationOptions);
};
export const sendRateChangedMessage = (
  emailRequestRateChangeApproved: EmailRequestRateChangeApproved
) => {
  return customInstance<void>({
    url: `/operations/mail/rate-changed`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailRequestRateChangeApproved,
  });
};

export const getSendRateChangedMessageMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendRateChangedMessage>>,
    TError,
    { data: EmailRequestRateChangeApproved },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendRateChangedMessage>>,
  TError,
  { data: EmailRequestRateChangeApproved },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendRateChangedMessage>>,
    { data: EmailRequestRateChangeApproved }
  > = (props) => {
    const { data } = props ?? {};

    return sendRateChangedMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendRateChangedMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendRateChangedMessage>>
>;
export type SendRateChangedMessageMutationBody = EmailRequestRateChangeApproved;
export type SendRateChangedMessageMutationError = unknown;

export const useSendRateChangedMessage = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendRateChangedMessage>>,
    TError,
    { data: EmailRequestRateChangeApproved },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendRateChangedMessage>>,
  TError,
  { data: EmailRequestRateChangeApproved },
  TContext
> => {
  const mutationOptions = getSendRateChangedMessageMutationOptions(options);

  return useMutation(mutationOptions);
};
export const sendEmailWelcomeMessage = (
  emailRequestBankWelcomeMessage: EmailRequestBankWelcomeMessage
) => {
  return customInstance<void>({
    url: `/operations/mail/welcome`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailRequestBankWelcomeMessage,
  });
};

export const getSendEmailWelcomeMessageMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmailWelcomeMessage>>,
    TError,
    { data: EmailRequestBankWelcomeMessage },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendEmailWelcomeMessage>>,
  TError,
  { data: EmailRequestBankWelcomeMessage },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendEmailWelcomeMessage>>,
    { data: EmailRequestBankWelcomeMessage }
  > = (props) => {
    const { data } = props ?? {};

    return sendEmailWelcomeMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendEmailWelcomeMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendEmailWelcomeMessage>>
>;
export type SendEmailWelcomeMessageMutationBody =
  EmailRequestBankWelcomeMessage;
export type SendEmailWelcomeMessageMutationError = unknown;

export const useSendEmailWelcomeMessage = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmailWelcomeMessage>>,
    TError,
    { data: EmailRequestBankWelcomeMessage },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendEmailWelcomeMessage>>,
  TError,
  { data: EmailRequestBankWelcomeMessage },
  TContext
> => {
  const mutationOptions = getSendEmailWelcomeMessageMutationOptions(options);

  return useMutation(mutationOptions);
};
